import React, { ReactNode } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import { styled } from '@mui/material/styles';

import Skeleton from '@mui/material/Skeleton';
import BusinessIcon from '@mui/icons-material/Business';

import { AdminedProject } from '@/admin/types/admined-project.dto';
import Subtitle from '@/components/Subtitle';
import { ProjectStatus } from '@bimdata/definitions/const';

const CardContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  color: '#344563',
  textDecoration: 'none',
  fontWeight: 500,
  fontSize: '14px',
});

const StyledLink = styled(Link)({
  color: 'inherit',
  textDecoration: 'none'
});

const ProjectLink = ({ to, children, ...props }: LinkProps) => {
  if (!to) return (<>{children}</>);
  return <StyledLink to={to} {...props}>{children}</StyledLink>;
};

const ProjectLogoContainer = styled('div')(({ empty }: { empty: boolean }) => ({
  minWidth: '74px',
  maxWidth: '74px',
  height: '40px',
  ...(empty ? {
    border: '1px solid #DADADA',
    borderRadius: '4px',
    textAlign: 'center',
  } : {})
}));

const ProjectLogo = styled('img')({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  verticalAlign: 'inherit',
  borderRadius: '4px',
});

const ProjectLogoPlaceholder = styled(BusinessIcon)({
  fontSize: '24px',
  color: '#C1C7D0',
  margin: '7px 0',
});

const ProjectLogoTitle = styled('div')({
  textOverflow: 'ellipsis',
  overflow: 'hidden',
});

export default ({ project, logo }: {
  project: AdminedProject,
  logo?: string | false | unknown,
}) => (
  <CardContainer>
    <ProjectLink to={project.status === ProjectStatus.USED ? `/project/${project.code}` : ''}>
      <ProjectLogoContainer empty={logo === false}>
        {(typeof logo === 'string')
          ? <ProjectLogo src={logo}/>
          : ((logo === false)
            ? <ProjectLogoPlaceholder/>
            : <Skeleton variant='rounded' width={74} height={40}></Skeleton>
          )
        }
      </ProjectLogoContainer>
    </ProjectLink>
    <ProjectLogoTitle>
      {project.status === ProjectStatus.USED
        ? <ProjectLink to={`/project/${project.code}`}>{project.name}</ProjectLink>
        : project.name
      }
      <Subtitle>{project.id}&nbsp;&bull;&nbsp;{project.code}</Subtitle>
    </ProjectLogoTitle>
  </CardContainer>
);